export enum MedicalSpecialty {
    None = 0,
    Odontoiatrica = 1,
    Fisioterapica = 2,
    OdontoFisio = Odontoiatrica + Fisioterapica,
    All = Odontoiatrica + Fisioterapica,
}